import { setupData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    setupData
  }
};
